import { Card, Typography, Box } from '@mui/material'
import { alpha, styled } from '@mui/material/styles'
import { Loading, useGetList } from 'react-admin'
import { ProductWidgetDashboardT } from './type'
import { FC } from 'react'
import palette from '../../themes/styles/palette'

const StyledIcon = styled('div')(({ theme }) => ({
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
}))

const ProductWidgetDashboard: FC<ProductWidgetDashboardT> = ({
  resource,
  title,
  color = 'primary',
  Icon,
  cardProp,
  resourceOptions,
}) => {
  const { sort } = resourceOptions
  const { total, isLoading } = useGetList(resource, {
    filter: {
      prod_item_status: 'N',
    },
    sort,
    meta: { isPaginate: false },
  })

  const { total: discontinueTotal, isLoading: discontinueIsLoading } = useGetList(resource, {
    filter: {
      prod_item_status: 'D',
    },
    sort,
    meta: { isPaginate: false },
  })

  if (isLoading || discontinueIsLoading) {
    return <Loading />
  }

  return (
    <Card
      sx={{
        p: 3,
        display: 'flex',
        justifyContent: 'space-between',
        color: (theme) => theme.palette[color].darker,
      }}
      {...cardProp}
    >
      <Box>
        <StyledIcon
          sx={{
            color: (theme) => theme.palette[color].dark,
            backgroundImage: (theme) =>
              `linear-gradient(135deg, ${alpha(theme.palette[color].dark, 0)} 0%, ${alpha(
                theme.palette[color].dark,
                0.24,
              )} 100%)`,
          }}
        >
          <Icon fill={palette[color]} />
        </StyledIcon>
        <Typography align='center' variant='subtitle2' sx={{ opacity: 0.72 }}>
          {title}
        </Typography>
      </Box>
      <Box>
        <Typography align='center' variant='subtitle2' sx={{ opacity: 0.72 }}>
          ปกติ
        </Typography>
        <Typography align='center' variant='h3'>
          {total?.toLocaleString() ?? 0}
        </Typography>
      </Box>
      <Box>
        <Typography align='center' variant='subtitle2' sx={{ opacity: 0.72 }}>
          ยกเลิกการขาย
        </Typography>
        <Typography align='center' variant='h3'>
          {discontinueTotal?.toLocaleString() ?? 0}
        </Typography>
      </Box>
      <Box>
        <Typography align='center' variant='subtitle2' sx={{ opacity: 0.72 }}>
          รวม
        </Typography>
        <Typography align='center' variant='h3'>
          {(total + discontinueTotal)?.toLocaleString() ?? 0}
        </Typography>
      </Box>
    </Card>
  )
}

export default ProductWidgetDashboard
